import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPostcard2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPostcard2"><Path fillRule="evenodd" clipRule="evenodd" d="M2 20V4H22V20H2ZM12 9V15H18V9H12ZM6 9.25V10.75H10V9.25H6ZM6 13.25V14.75H10V13.25H6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPostcard2;
